/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Create_Last_NameInputs */

const en_admin_create_last_name = /** @type {(inputs: Admin_Create_Last_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Name`)
};

const de_admin_create_last_name = /** @type {(inputs: Admin_Create_Last_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachname`)
};

/**
* | output |
* | --- |
* | "Last Name" |
*
* @param {Admin_Create_Last_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_create_last_name = /** @type {((inputs?: Admin_Create_Last_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Create_Last_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_create_last_name(inputs)
	return en_admin_create_last_name(inputs)
});